module.exports = __webpack_public_path__ + "static/media/EPLD@2x(Grey).76fb7deb.png";